// extracted by mini-css-extract-plugin
export var black = "_3i-6";
export var brand = "_3i-1";
export var ddefault = "_3i-0";
export var error = "_3i-3";
export var gray = "_3i-2";
export var highContrast = "_3i-8";
export var outline = "_3i-7";
export var success = "_3i-5";
export var warning = "_3i-4";